var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('data-table',{attrs:{"columns":_vm.employeeColumnNames,"tableData":_vm.employeeDataForOffCycle,"withForm":false,"showhistory":false,"showedit":false,"showdelete":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }